import { noop } from '@utils/noop';
import { DateInputAssets } from '../DateInputAssets/DateInputAssets';

interface UnEditableFieldProps {
  value: Date;
  /** Equipment interface field this relates to. E.g: `createdAt` */
  fieldName: string;
}
/**
 * A minimal disabled input field for Inventory item properties.
 * This was created with createdAt in mind. Can be more general.
 * E.g: One can make value generic and default as Date. Then check inside the component if Value is Date, if it is, then render DateInput, else render any other input you want.
 */
export function UnEditableField(props: UnEditableFieldProps) {
  const { value, fieldName: field } = props;
  const tip = 'This is an Uneditable Standard Field';
  return (
    <div data-tip={tip} data-for={`editAssetData-${field}`} data-event="click">
      <DateInputAssets handleDateChange={noop} disabled value={value} />
    </div>
  );
}
